export default "__VITE_ASSET__CykLhN_m__"